import './utils/dayjs'
import ReactDOM from 'react-dom/client'
import './styles/index.css'
import I18NServer from './components/i18n-server'
import { Provider } from 'react-redux'
import store from './store'
import './iconfont/iconfont'
import ConfigProviderWrapper from './configProvider'
import { EventEmitterContextProvider } from './context/event-emitter.tsx'
import './assets/index'
import App from './App.tsx'
import { HashRouter } from 'react-router-dom'
import PhoneProvider from './next/PhoneProvider'
import { isLlmbotNext } from './next/runtime.mjs'
// import KeepAlive from './keepAlive.tsx'
import { AliveScope } from 'react-activation'

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <Provider store={store}>
    <EventEmitterContextProvider>
      <I18NServer>
        {locale => {
          return (
            <ConfigProviderWrapper locale={locale}>
              <HashRouter>
                {isLlmbotNext(process.env) ? (
                  <PhoneProvider>
                    <AliveScope>
                      <App />
                    </AliveScope>
                  </PhoneProvider>
                ) : (
                  <AliveScope>
                    <App />
                  </AliveScope>
                )}
              </HashRouter>
            </ConfigProviderWrapper>
          )
        }}
      </I18NServer>
    </EventEmitterContextProvider>
  </Provider>
)
